import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-skeleton.css';
var getClassNameList = classNames.bind(styles);
var UitkSkeleton = function (props) {
  var className = props.className,
    animation = props.animation;
  var wrapperClassNames = getClassNameList(UitkSkeleton.baseClassName, className, animation && "".concat(UitkSkeleton.baseClassName, "-animation"));
  return React.createElement("div", {
    className: wrapperClassNames,
    role: "presentation"
  });
};
UitkSkeleton.baseClassName = 'uitk-skeleton';
UitkSkeleton.defaultProps = {
  animation: true
};
UitkSkeleton.displayName = 'UitkSkeleton';
export { UitkSkeleton };